import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import { AddendumListModal, AddendumListItem, ChiamaAPI, Bottone, Trad, Paginatore, Tipo, BaseComponent, CampoData } from '../components/';
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-responsive-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';

interface IAddendumListState {
    IsLoading: boolean;
    PaginationParams: Dati.CParamAPIPagine;
    SearchParams: Dati.TListaParametri;
    UpdateNumber: number;
    Data?: Dati.CRisAPIPagineAppendice;
}

export class AddendumList extends BaseComponent<Glob.IRouteGlobaleProps, IAddendumListState> {
    private Table: any = null;
    private TableOrder: [number, string] = [0, 'desc'];
    private TableUpdate: number = 0;
    private TableColumnsNames: string[] = [
        'ID_Appendice',
        'ID_TipoAppendice',
        'ID_TipoAppendiceStato',
        'NumeroAppendice',
        'PolizzaAppendice',
        'ID_Polizza',
        'Polizza',
        'DataEffetto',
        'DataScadenza',
        'Dati',
        'Operazione',
        'Nota'
    ];

    public constructor(props: any) {
        super(props);

        let PaginationParams: Dati.CParamAPIPagine = new Dati.CParamAPIPagine();
        PaginationParams.Sessione = Glob.GetSessione().Sessione;
        PaginationParams.Numero = 10;
        PaginationParams.Pagina = 1;

        this.state = {
            Data: undefined,
            IsLoading: true,
            SearchParams: {
                OrdinaCampo: 'ID_Appendice',
                OrdinaVerso: 'DESC'
            },
            UpdateNumber: 1,
            PaginationParams
        };

        this.OnChange = this.OnChange.bind(this);
        this.OnPageChange = this.OnPageChange.bind(this);
        this.OnSearch = this.OnSearch.bind(this);
        this.OnSearchRequest = this.OnSearchRequest.bind(this);
        this.OnSearchResponse = this.OnSearchResponse.bind(this);
        this.OnSearchError = this.OnSearchError.bind(this);
        this.OnStatusChange = this.OnStatusChange.bind(this);

        this.InitTable();
    }

    private InitTable() {
        if (this.TableUpdate != this.state.UpdateNumber) {
            this.TableUpdate = this.state.UpdateNumber;
            if (this.state.Data != undefined) {
                let T: any = $(this.refs.table);
                
                this.Table = T.DataTable({
                    responsive: true,
                    paging: false,
                    searching: false,
                    info: false,
                    ordering: true,
                    destroy: true,
                    order: this.TableOrder,
                    columnDefs: [
                        {
                            targets: [4, 6, 9, 10, 11],
                            orderable: false
                        }
                    ]
                });

                T.one('order.dt', (e: any, settings: any) => {
                    let TO: any = this.Table.order();
                    if (TO != undefined && TO[0] != undefined) {
                        let columnName = '';

                        this.TableOrder[1] = TO[0][1];
                        this.TableOrder[0] = TO[0][0];
                        columnName = this.TableColumnsNames[this.TableOrder[0]];
                        this.OnSort(columnName, this.TableOrder[1].toUpperCase());
                    }
                });
            }
        }
    }

    private OnSort(Name: string, Order: string) {
        this.setState({
            SearchParams: {
                ...this.state.SearchParams,
                OrdinaCampo: Name,
                OrdinaVerso: Order
            },
            UpdateNumber: this.state.UpdateNumber + 1,
            IsLoading: true
        });
    }

    private OnStatusChange() {
        this.setState({
            UpdateNumber: this.state.UpdateNumber + 1,
            IsLoading: true
        });
    }

    private OnSearchError(sender: ChiamaAPI, error: Error): React.ReactNode {
        this.setState({ IsLoading: false });
        return <tbody><tr><td colSpan={12}>{Trad.Trad("ListaErrore")}</td></tr></tbody>;
    }

    private OnSearch() {
        this.setState({
            IsLoading: true,
            PaginationParams: {
                ...this.state.PaginationParams,
                Pagina: 1
            },
            UpdateNumber: this.state.UpdateNumber + 1
        });
    }

    private OnSearchResponse(sender: ChiamaAPI, data: Dati.CRisAPIPagineAppendice, newData: boolean): React.ReactNode {
        if (newData) {
            this.TableUpdate = 0;
            if (this.Table != null) {
                this.Table.destroy();
            }
            this.setState({ Data: data, IsLoading: false }, this.InitTable);
        }
        if (data.Errore) {
            return false;
        }
        return true;
    }

    private OnSearchRequest(sender: ChiamaAPI) {
        return this.CopiaListaParametri(this.state.SearchParams, true);
    }

    private OnPageChange(sender: Paginatore, page: number) {
        this.setState({
            IsLoading: true,
            PaginationParams: {
                ...this.state.PaginationParams,
                Pagina: page
            },
            UpdateNumber: this.state.UpdateNumber + 1
        });
    }

    public render() {
        const data = this.state.Data;
    
        return(
            <div className="kt-portlet">
                <div className="kt-portlet__head">
                    <div className="kt-portlet__head-label">
                        <div className="kt-portlet__head-label">
                            <span className="kt-portlet__head-icon"><i className="fa fa-sticky-note" /></span>
                            <h3 className="kt-portlet__head-label">{Trad.Trad("Addendums")}</h3>
                        </div>
                    </div>
                </div>
                <form className="kt-form vertical-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                    <div className="kt-portlet__body">
                        <div className="form-group kt-form login-form__group row">
                            <label className="col-lg-1 col-form-label">{Trad.Trad("ID")}</label>
                            <div className="col-lg-3 form-control-plaintext">
                                <input onChange={this.OnChange} type="text" value={this.state.SearchParams['ID_Appendice'] || ''} name="SearchParams[ID_Appendice]" className="form-control kt-input" />
                            </div>
                            <label className="col-lg-1 col-form-label">{Trad.Trad("ID_Polizza")}</label>
                            <div className="col-lg-3 form-control-plaintext">
                                <div className="kt-input-icon kt-input-icon--right">
                                    <input onChange={this.OnChange} type="text" value={this.state.SearchParams['ID_Polizza'] || ''} name="SearchParams[ID_Polizza]" className="form-control kt-input" />
                                </div>
                            </div>
                            <label className="col-lg-1 col-form-label">{Trad.Trad("Status")}</label>
                            <div className="col-lg-3 form-control-plaintext">
                                <Tipo
                                    Campo="SearchParams[ID_TipoAppendiceStato]"
                                    ID_ChiaveString={this.state.SearchParams['ID_TipoAppendiceStato'] || ''}
                                    OnAggiorna={this.OnChange}
                                    URL="/api/Tipi/ListaTipi?ID_TipoContesto=AppendiceStato"
                                    TradValori={false}
                                />
                            </div>
                        </div>

                        <div className="form-group kt-form login-form__group row">
                            <label className="col-lg-1 col-form-label">{Trad.Trad("Polizza")}</label>
                            <div className="col-lg-3 form-control-plaintext">
                                <input onChange={this.OnChange} type="text" value={this.state.SearchParams['Polizza'] || ''} name="SearchParams[Polizza]" className="form-control kt-input" />
                            </div>
                            <label className="col-lg-1 col-form-label">{Trad.Trad("Endorsement number")}</label>
                            <div className="col-lg-3 form-control-plaintext">
                                <div className="kt-input-icon kt-input-icon--right">
                                    <input onChange={this.OnChange} type="text" value={this.state.SearchParams['PolizzaAppendice'] || ''} name="SearchParams[PolizzaAppendice]" className="form-control kt-input" />
                                </div>
                            </div>
                            <label className="col-lg-1 col-form-label">{Trad.Trad("Tipo")}</label>
                            <div className="col-lg-3 form-control-plaintext">
                                <Tipo
                                    Campo="SearchParams[ID_TipoAppendice]"
                                    ID_ChiaveString={this.state.SearchParams['ID_TipoAppendice'] || ''}
                                    OnAggiorna={this.OnChange}
                                    URL="/api/Tipi/ListaTipi?ID_TipoContesto=AppendiceTipo"
                                    TradValori={false}
                                />
                            </div>
                        </div>
                        
                        <div className="form-group kt-form login-form__group row">
                            <label className="col-lg-1 col-form-label">{Trad.Trad("DataEffetto")}</label>
                            <div className="col-lg-3 kt-input-icon kt-input-icon--right">
                                <div className="form-control ">
                                    <CampoData
                                        ValoreInArrivo={false}
                                        Name="SearchParams[DataEffetto]"
                                        Id="SearchParams[DataEffetto]"
                                        Valore={this.state.SearchParams["DataEffetto"]}
                                        OnChange={this.OnChange}
                                        IsClearable
                                    />
                                </div>
                            </div>
                            <label className="col-lg-1 col-form-label">{Trad.Trad("DataScadenza")}</label>
                            <div className="col-lg-3 kt-input-icon kt-input-icon--right">
                                <div className="form-control">
                                    <CampoData
                                        ValoreInArrivo={false}
                                        Name="SearchParams[DataScadenza]"
                                        Id="SearchParams[DataScadenza]"
                                        Valore={this.state.SearchParams["DataScadenza"]}
                                        OnChange={this.OnChange}
                                        IsClearable
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="kt-portlet__foot kt-portlet__foot--fit">
                        <div className="kt-form login-form__actions kt-form login-form__actions--middle">
                            <div className="row">
                                <div className="col-lg-12 kt-form__actions kt-form__actions--center">
                                    <Bottone Default Attesa={this.state.IsLoading} OnClick={this.OnSearch} Testo={Trad.Trad("Cerca")} />
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <Paginatore
                    Pagina={this.state.PaginationParams.Pagina}
                    Pagine={this.state.Data && this.state.Data.Pagine || 0}
                    OnCambioPagina={this.OnPageChange}
                />
                <div>
                    <table className="table table-hover dtr-inline dataTable" id="table" ref="table">
                        <thead>
                            <tr className="sfondoTab">
                                <th data-field="ID_Appendice" className="TextCenter">ID</th>
                                <th data-field="ID_TipoAppendice" className="TextLeft">{Trad.Trad("Tipo")}</th>
                                <th data-field="ID_TipoAppendiceStato" className="TextLeft">{Trad.Trad("Stato")}</th>
                                <th data-field="NumeroAppendice" className="TextCenter">{Trad.Trad("Number")}</th>
                                <th data-field="PolizzaAppendice" className="TextLeft">{Trad.Trad("Endorsement number")}</th>
                                <th data-field="ID_Polizza" className="TextLeft">{Trad.Trad("Policy ID")}</th>
                                <th data-field="Polizza" className="TextLeft">{Trad.Trad("Polizza")}</th>
                                <th data-field="DataEffetto" className="TextCenter">{Trad.Trad("DataEffetto")}</th>
                                <th data-field="DataScadenza" className="TextCenter">{Trad.Trad("DataScadenza")}</th>
                                <th data-field="Dati" className="TextCenter">{Trad.Trad("Dati deroga")}</th>
                                <th data-field="Operazione" className="TextCenter">{Trad.Trad("Operazione")}</th>
                                <th data-field="Nota" className="TextCenter">{Trad.Trad("Note")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data && data.Dati && data.Dati.length === 0 &&
                                <tr>
                                    <td colSpan={12} className="TextLeft alert-warning">
                                        <div className="kt-alert__icon">
                                            <i className="fa fa-exclamation-triangle"> </i>
                                            <span>{Trad.Trad("Nessun record corrisponde ai parametri di ricerca")}</span>
                                        </div>
                                    </td>
                                </tr>
                            }
                            {data && data.Dati && data.Dati.length > 0 &&
                                data.Dati.map(item => <AddendumListItem key={item.ID_Appendice} Data={item} />)
                            }
                        </tbody>
                    </table>
                    <ChiamaAPI
                        Aggiornare={this.state.UpdateNumber}
                        URL="/api/Appendice/Search"
                        ParamURLClasse={this.state.PaginationParams}
                        OnInvio={this.OnSearchRequest}
                        OnRis={this.OnSearchResponse}
                        OnErrore={this.OnSearchError}
                    />
                    {data && data.Dati && data.Dati.length > 0 &&
                        data.Dati.map(item => <AddendumListModal key={item.ID_Appendice} Data={item} OnStatusChange={this.OnStatusChange} />)
                    }
                </div>
            </div >
        );
    }
}



// WEBPACK FOOTER //
// ./src/form/AddendumList.tsx